/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as UiTestRouteImport } from './routes/ui-test'
import { Route as UsersRouteImport } from './routes/users'
import { Route as AdminApprovalsRouteImport } from './routes/admin/approvals'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminInvitesRouteImport } from './routes/admin/invites'
import { Route as IconsLayoutRouteImport } from './routes/icons._layout'
import { Route as IconsGettingStartedRouteImport } from './routes/icons.getting-started'
import { Route as UiLayoutRouteImport } from './routes/ui._layout'
import { Route as UiGettingStartedRouteImport } from './routes/ui.getting-started'
import { Route as IconsLayoutIndexRouteImport } from './routes/icons._layout.index'
import { Route as UiLayoutIndexRouteImport } from './routes/ui._layout.index'
import { Route as UiLayoutAlertRouteImport } from './routes/ui._layout.alert'
import { Route as UiLayoutBadgeRouteImport } from './routes/ui._layout.badge'
import { Route as UiLayoutBannerRouteImport } from './routes/ui._layout.banner'
import { Route as UiLayoutButtonRouteImport } from './routes/ui._layout.button'
import { Route as UiLayoutButtonGroupRouteImport } from './routes/ui._layout.button-group'
import { Route as UiLayoutCardRouteImport } from './routes/ui._layout.card'
import { Route as UiLayoutCheckboxRouteImport } from './routes/ui._layout.checkbox'
import { Route as UiLayoutCodeBlockRouteImport } from './routes/ui._layout.code-block'
import { Route as UiLayoutColorPickerRouteImport } from './routes/ui._layout.color-picker'
import { Route as UiLayoutEmptyStateRouteImport } from './routes/ui._layout.empty-state'
import { Route as UiLayoutErrorSummaryRouteImport } from './routes/ui._layout.error-summary'
import { Route as UiLayoutFieldsetRouteImport } from './routes/ui._layout.fieldset'
import { Route as UiLayoutFileInputRouteImport } from './routes/ui._layout.file-input'
import { Route as UiLayoutFormRouteImport } from './routes/ui._layout.form'
import { Route as UiLayoutGridRouteImport } from './routes/ui._layout.grid'
import { Route as UiLayoutHeadingRouteImport } from './routes/ui._layout.heading'
import { Route as UiLayoutInputRouteImport } from './routes/ui._layout.input'
import { Route as UiLayoutInputGroupRouteImport } from './routes/ui._layout.input-group'
import { Route as UiLayoutLabelRouteImport } from './routes/ui._layout.label'
import { Route as UiLayoutLoadingStateRouteImport } from './routes/ui._layout.loading-state'
import { Route as UiLayoutLoginFormRouteImport } from './routes/ui._layout.login-form'
import { Route as UiLayoutModalRouteImport } from './routes/ui._layout.modal'
import { Route as UiLayoutPillRouteImport } from './routes/ui._layout.pill'
import { Route as UiLayoutProgressRouteImport } from './routes/ui._layout.progress'
import { Route as UiLayoutRadioRouteImport } from './routes/ui._layout.radio'
import { Route as UiLayoutRangeRouteImport } from './routes/ui._layout.range'
import { Route as UiLayoutSelectRouteImport } from './routes/ui._layout.select'
import { Route as UiLayoutSidebarRouteImport } from './routes/ui._layout.sidebar'
import { Route as UiLayoutSkeletonRouteImport } from './routes/ui._layout.skeleton'
import { Route as UiLayoutSpinnerRouteImport } from './routes/ui._layout.spinner'
import { Route as UiLayoutStackRouteImport } from './routes/ui._layout.stack'
import { Route as UiLayoutSwitchRouteImport } from './routes/ui._layout.switch'
import { Route as UiLayoutTableRouteImport } from './routes/ui._layout.table'
import { Route as UiLayoutTabsRouteImport } from './routes/ui._layout.tabs'
import { Route as UiLayoutTextRouteImport } from './routes/ui._layout.text'
import { Route as UiLayoutTextareaRouteImport } from './routes/ui._layout.textarea'
import { Route as UiLayoutThemeSwitchRouteImport } from './routes/ui._layout.theme-switch'
import { Route as UiLayoutToastRouteImport } from './routes/ui._layout.toast'
import { Route as UiLayoutTooltipRouteImport } from './routes/ui._layout.tooltip'
import { Route as UiLayoutUseFormRouteImport } from './routes/ui._layout.use-form'
import { Route as UiLayoutUtilitiesRouteImport } from './routes/ui._layout.utilities'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const UiTestRoute = UiTestRouteImport.update({
  id: '/ui-test',
  path: '/ui-test',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
  id: '/admin/approvals',
  path: '/admin/approvals',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminInvitesRoute = AdminInvitesRouteImport.update({
  id: '/admin/invites',
  path: '/admin/invites',
  getParentRoute: () => rootRouteImport,
} as any)
const IconsLayoutRoute = IconsLayoutRouteImport.update({
  id: '/icons/_layout',
  path: '/icons',
  getParentRoute: () => rootRouteImport,
} as any)
const IconsGettingStartedRoute = IconsGettingStartedRouteImport.update({
  id: '/icons/getting-started',
  path: '/icons/getting-started',
  getParentRoute: () => rootRouteImport,
} as any)
const UiLayoutRoute = UiLayoutRouteImport.update({
  id: '/ui/_layout',
  path: '/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const UiGettingStartedRoute = UiGettingStartedRouteImport.update({
  id: '/ui/getting-started',
  path: '/ui/getting-started',
  getParentRoute: () => rootRouteImport,
} as any)
const IconsLayoutIndexRoute = IconsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IconsLayoutRoute,
} as any)
const UiLayoutIndexRoute = UiLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutAlertRoute = UiLayoutAlertRouteImport.update({
  id: '/alert',
  path: '/alert',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutBadgeRoute = UiLayoutBadgeRouteImport.update({
  id: '/badge',
  path: '/badge',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutBannerRoute = UiLayoutBannerRouteImport.update({
  id: '/banner',
  path: '/banner',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutButtonRoute = UiLayoutButtonRouteImport.update({
  id: '/button',
  path: '/button',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutButtonGroupRoute = UiLayoutButtonGroupRouteImport.update({
  id: '/button-group',
  path: '/button-group',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutCardRoute = UiLayoutCardRouteImport.update({
  id: '/card',
  path: '/card',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutCheckboxRoute = UiLayoutCheckboxRouteImport.update({
  id: '/checkbox',
  path: '/checkbox',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutCodeBlockRoute = UiLayoutCodeBlockRouteImport.update({
  id: '/code-block',
  path: '/code-block',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutColorPickerRoute = UiLayoutColorPickerRouteImport.update({
  id: '/color-picker',
  path: '/color-picker',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutEmptyStateRoute = UiLayoutEmptyStateRouteImport.update({
  id: '/empty-state',
  path: '/empty-state',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutErrorSummaryRoute = UiLayoutErrorSummaryRouteImport.update({
  id: '/error-summary',
  path: '/error-summary',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutFieldsetRoute = UiLayoutFieldsetRouteImport.update({
  id: '/fieldset',
  path: '/fieldset',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutFileInputRoute = UiLayoutFileInputRouteImport.update({
  id: '/file-input',
  path: '/file-input',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutFormRoute = UiLayoutFormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutGridRoute = UiLayoutGridRouteImport.update({
  id: '/grid',
  path: '/grid',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutHeadingRoute = UiLayoutHeadingRouteImport.update({
  id: '/heading',
  path: '/heading',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutInputRoute = UiLayoutInputRouteImport.update({
  id: '/input',
  path: '/input',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutInputGroupRoute = UiLayoutInputGroupRouteImport.update({
  id: '/input-group',
  path: '/input-group',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutLabelRoute = UiLayoutLabelRouteImport.update({
  id: '/label',
  path: '/label',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutLoadingStateRoute = UiLayoutLoadingStateRouteImport.update({
  id: '/loading-state',
  path: '/loading-state',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutLoginFormRoute = UiLayoutLoginFormRouteImport.update({
  id: '/login-form',
  path: '/login-form',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutModalRoute = UiLayoutModalRouteImport.update({
  id: '/modal',
  path: '/modal',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutPillRoute = UiLayoutPillRouteImport.update({
  id: '/pill',
  path: '/pill',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutProgressRoute = UiLayoutProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutRadioRoute = UiLayoutRadioRouteImport.update({
  id: '/radio',
  path: '/radio',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutRangeRoute = UiLayoutRangeRouteImport.update({
  id: '/range',
  path: '/range',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutSelectRoute = UiLayoutSelectRouteImport.update({
  id: '/select',
  path: '/select',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutSidebarRoute = UiLayoutSidebarRouteImport.update({
  id: '/sidebar',
  path: '/sidebar',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutSkeletonRoute = UiLayoutSkeletonRouteImport.update({
  id: '/skeleton',
  path: '/skeleton',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutSpinnerRoute = UiLayoutSpinnerRouteImport.update({
  id: '/spinner',
  path: '/spinner',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutStackRoute = UiLayoutStackRouteImport.update({
  id: '/stack',
  path: '/stack',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutSwitchRoute = UiLayoutSwitchRouteImport.update({
  id: '/switch',
  path: '/switch',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutTableRoute = UiLayoutTableRouteImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutTabsRoute = UiLayoutTabsRouteImport.update({
  id: '/tabs',
  path: '/tabs',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutTextRoute = UiLayoutTextRouteImport.update({
  id: '/text',
  path: '/text',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutTextareaRoute = UiLayoutTextareaRouteImport.update({
  id: '/textarea',
  path: '/textarea',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutThemeSwitchRoute = UiLayoutThemeSwitchRouteImport.update({
  id: '/theme-switch',
  path: '/theme-switch',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutToastRoute = UiLayoutToastRouteImport.update({
  id: '/toast',
  path: '/toast',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutTooltipRoute = UiLayoutTooltipRouteImport.update({
  id: '/tooltip',
  path: '/tooltip',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutUseFormRoute = UiLayoutUseFormRouteImport.update({
  id: '/use-form',
  path: '/use-form',
  getParentRoute: () => UiLayoutRoute,
} as any)
const UiLayoutUtilitiesRoute = UiLayoutUtilitiesRouteImport.update({
  id: '/utilities',
  path: '/utilities',
  getParentRoute: () => UiLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/ui-test': typeof UiTestRoute
  '/users': typeof UsersRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/icons': typeof IconsLayoutRouteWithChildren
  '/icons/getting-started': typeof IconsGettingStartedRoute
  '/ui': typeof UiLayoutRouteWithChildren
  '/ui/getting-started': typeof UiGettingStartedRoute
  '/ui/alert': typeof UiLayoutAlertRoute
  '/ui/badge': typeof UiLayoutBadgeRoute
  '/ui/banner': typeof UiLayoutBannerRoute
  '/ui/button': typeof UiLayoutButtonRoute
  '/ui/button-group': typeof UiLayoutButtonGroupRoute
  '/ui/card': typeof UiLayoutCardRoute
  '/ui/checkbox': typeof UiLayoutCheckboxRoute
  '/ui/code-block': typeof UiLayoutCodeBlockRoute
  '/ui/color-picker': typeof UiLayoutColorPickerRoute
  '/ui/empty-state': typeof UiLayoutEmptyStateRoute
  '/ui/error-summary': typeof UiLayoutErrorSummaryRoute
  '/ui/fieldset': typeof UiLayoutFieldsetRoute
  '/ui/file-input': typeof UiLayoutFileInputRoute
  '/ui/form': typeof UiLayoutFormRoute
  '/ui/grid': typeof UiLayoutGridRoute
  '/ui/heading': typeof UiLayoutHeadingRoute
  '/ui/input': typeof UiLayoutInputRoute
  '/ui/input-group': typeof UiLayoutInputGroupRoute
  '/ui/label': typeof UiLayoutLabelRoute
  '/ui/loading-state': typeof UiLayoutLoadingStateRoute
  '/ui/login-form': typeof UiLayoutLoginFormRoute
  '/ui/modal': typeof UiLayoutModalRoute
  '/ui/pill': typeof UiLayoutPillRoute
  '/ui/progress': typeof UiLayoutProgressRoute
  '/ui/radio': typeof UiLayoutRadioRoute
  '/ui/range': typeof UiLayoutRangeRoute
  '/ui/select': typeof UiLayoutSelectRoute
  '/ui/sidebar': typeof UiLayoutSidebarRoute
  '/ui/skeleton': typeof UiLayoutSkeletonRoute
  '/ui/spinner': typeof UiLayoutSpinnerRoute
  '/ui/stack': typeof UiLayoutStackRoute
  '/ui/switch': typeof UiLayoutSwitchRoute
  '/ui/table': typeof UiLayoutTableRoute
  '/ui/tabs': typeof UiLayoutTabsRoute
  '/ui/text': typeof UiLayoutTextRoute
  '/ui/textarea': typeof UiLayoutTextareaRoute
  '/ui/theme-switch': typeof UiLayoutThemeSwitchRoute
  '/ui/toast': typeof UiLayoutToastRoute
  '/ui/tooltip': typeof UiLayoutTooltipRoute
  '/ui/use-form': typeof UiLayoutUseFormRoute
  '/ui/utilities': typeof UiLayoutUtilitiesRoute
  '/icons/': typeof IconsLayoutIndexRoute
  '/ui/': typeof UiLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/ui-test': typeof UiTestRoute
  '/users': typeof UsersRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/icons/getting-started': typeof IconsGettingStartedRoute
  '/ui/getting-started': typeof UiGettingStartedRoute
  '/ui/alert': typeof UiLayoutAlertRoute
  '/ui/badge': typeof UiLayoutBadgeRoute
  '/ui/banner': typeof UiLayoutBannerRoute
  '/ui/button': typeof UiLayoutButtonRoute
  '/ui/button-group': typeof UiLayoutButtonGroupRoute
  '/ui/card': typeof UiLayoutCardRoute
  '/ui/checkbox': typeof UiLayoutCheckboxRoute
  '/ui/code-block': typeof UiLayoutCodeBlockRoute
  '/ui/color-picker': typeof UiLayoutColorPickerRoute
  '/ui/empty-state': typeof UiLayoutEmptyStateRoute
  '/ui/error-summary': typeof UiLayoutErrorSummaryRoute
  '/ui/fieldset': typeof UiLayoutFieldsetRoute
  '/ui/file-input': typeof UiLayoutFileInputRoute
  '/ui/form': typeof UiLayoutFormRoute
  '/ui/grid': typeof UiLayoutGridRoute
  '/ui/heading': typeof UiLayoutHeadingRoute
  '/ui/input': typeof UiLayoutInputRoute
  '/ui/input-group': typeof UiLayoutInputGroupRoute
  '/ui/label': typeof UiLayoutLabelRoute
  '/ui/loading-state': typeof UiLayoutLoadingStateRoute
  '/ui/login-form': typeof UiLayoutLoginFormRoute
  '/ui/modal': typeof UiLayoutModalRoute
  '/ui/pill': typeof UiLayoutPillRoute
  '/ui/progress': typeof UiLayoutProgressRoute
  '/ui/radio': typeof UiLayoutRadioRoute
  '/ui/range': typeof UiLayoutRangeRoute
  '/ui/select': typeof UiLayoutSelectRoute
  '/ui/sidebar': typeof UiLayoutSidebarRoute
  '/ui/skeleton': typeof UiLayoutSkeletonRoute
  '/ui/spinner': typeof UiLayoutSpinnerRoute
  '/ui/stack': typeof UiLayoutStackRoute
  '/ui/switch': typeof UiLayoutSwitchRoute
  '/ui/table': typeof UiLayoutTableRoute
  '/ui/tabs': typeof UiLayoutTabsRoute
  '/ui/text': typeof UiLayoutTextRoute
  '/ui/textarea': typeof UiLayoutTextareaRoute
  '/ui/theme-switch': typeof UiLayoutThemeSwitchRoute
  '/ui/toast': typeof UiLayoutToastRoute
  '/ui/tooltip': typeof UiLayoutTooltipRoute
  '/ui/use-form': typeof UiLayoutUseFormRoute
  '/ui/utilities': typeof UiLayoutUtilitiesRoute
  '/icons': typeof IconsLayoutIndexRoute
  '/ui': typeof UiLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/ui-test': typeof UiTestRoute
  '/users': typeof UsersRoute
  '/admin/approvals': typeof AdminApprovalsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/invites': typeof AdminInvitesRoute
  '/icons/_layout': typeof IconsLayoutRouteWithChildren
  '/icons/getting-started': typeof IconsGettingStartedRoute
  '/ui/_layout': typeof UiLayoutRouteWithChildren
  '/ui/getting-started': typeof UiGettingStartedRoute
  '/ui/_layout/alert': typeof UiLayoutAlertRoute
  '/ui/_layout/badge': typeof UiLayoutBadgeRoute
  '/ui/_layout/banner': typeof UiLayoutBannerRoute
  '/ui/_layout/button': typeof UiLayoutButtonRoute
  '/ui/_layout/button-group': typeof UiLayoutButtonGroupRoute
  '/ui/_layout/card': typeof UiLayoutCardRoute
  '/ui/_layout/checkbox': typeof UiLayoutCheckboxRoute
  '/ui/_layout/code-block': typeof UiLayoutCodeBlockRoute
  '/ui/_layout/color-picker': typeof UiLayoutColorPickerRoute
  '/ui/_layout/empty-state': typeof UiLayoutEmptyStateRoute
  '/ui/_layout/error-summary': typeof UiLayoutErrorSummaryRoute
  '/ui/_layout/fieldset': typeof UiLayoutFieldsetRoute
  '/ui/_layout/file-input': typeof UiLayoutFileInputRoute
  '/ui/_layout/form': typeof UiLayoutFormRoute
  '/ui/_layout/grid': typeof UiLayoutGridRoute
  '/ui/_layout/heading': typeof UiLayoutHeadingRoute
  '/ui/_layout/input': typeof UiLayoutInputRoute
  '/ui/_layout/input-group': typeof UiLayoutInputGroupRoute
  '/ui/_layout/label': typeof UiLayoutLabelRoute
  '/ui/_layout/loading-state': typeof UiLayoutLoadingStateRoute
  '/ui/_layout/login-form': typeof UiLayoutLoginFormRoute
  '/ui/_layout/modal': typeof UiLayoutModalRoute
  '/ui/_layout/pill': typeof UiLayoutPillRoute
  '/ui/_layout/progress': typeof UiLayoutProgressRoute
  '/ui/_layout/radio': typeof UiLayoutRadioRoute
  '/ui/_layout/range': typeof UiLayoutRangeRoute
  '/ui/_layout/select': typeof UiLayoutSelectRoute
  '/ui/_layout/sidebar': typeof UiLayoutSidebarRoute
  '/ui/_layout/skeleton': typeof UiLayoutSkeletonRoute
  '/ui/_layout/spinner': typeof UiLayoutSpinnerRoute
  '/ui/_layout/stack': typeof UiLayoutStackRoute
  '/ui/_layout/switch': typeof UiLayoutSwitchRoute
  '/ui/_layout/table': typeof UiLayoutTableRoute
  '/ui/_layout/tabs': typeof UiLayoutTabsRoute
  '/ui/_layout/text': typeof UiLayoutTextRoute
  '/ui/_layout/textarea': typeof UiLayoutTextareaRoute
  '/ui/_layout/theme-switch': typeof UiLayoutThemeSwitchRoute
  '/ui/_layout/toast': typeof UiLayoutToastRoute
  '/ui/_layout/tooltip': typeof UiLayoutTooltipRoute
  '/ui/_layout/use-form': typeof UiLayoutUseFormRoute
  '/ui/_layout/utilities': typeof UiLayoutUtilitiesRoute
  '/icons/_layout/': typeof IconsLayoutIndexRoute
  '/ui/_layout/': typeof UiLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/login'
    | '/register'
    | '/ui-test'
    | '/users'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/invites'
    | '/icons'
    | '/icons/getting-started'
    | '/ui'
    | '/ui/getting-started'
    | '/ui/alert'
    | '/ui/badge'
    | '/ui/banner'
    | '/ui/button'
    | '/ui/button-group'
    | '/ui/card'
    | '/ui/checkbox'
    | '/ui/code-block'
    | '/ui/color-picker'
    | '/ui/empty-state'
    | '/ui/error-summary'
    | '/ui/fieldset'
    | '/ui/file-input'
    | '/ui/form'
    | '/ui/grid'
    | '/ui/heading'
    | '/ui/input'
    | '/ui/input-group'
    | '/ui/label'
    | '/ui/loading-state'
    | '/ui/login-form'
    | '/ui/modal'
    | '/ui/pill'
    | '/ui/progress'
    | '/ui/radio'
    | '/ui/range'
    | '/ui/select'
    | '/ui/sidebar'
    | '/ui/skeleton'
    | '/ui/spinner'
    | '/ui/stack'
    | '/ui/switch'
    | '/ui/table'
    | '/ui/tabs'
    | '/ui/text'
    | '/ui/textarea'
    | '/ui/theme-switch'
    | '/ui/toast'
    | '/ui/tooltip'
    | '/ui/use-form'
    | '/ui/utilities'
    | '/icons/'
    | '/ui/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/login'
    | '/register'
    | '/ui-test'
    | '/users'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/invites'
    | '/icons/getting-started'
    | '/ui/getting-started'
    | '/ui/alert'
    | '/ui/badge'
    | '/ui/banner'
    | '/ui/button'
    | '/ui/button-group'
    | '/ui/card'
    | '/ui/checkbox'
    | '/ui/code-block'
    | '/ui/color-picker'
    | '/ui/empty-state'
    | '/ui/error-summary'
    | '/ui/fieldset'
    | '/ui/file-input'
    | '/ui/form'
    | '/ui/grid'
    | '/ui/heading'
    | '/ui/input'
    | '/ui/input-group'
    | '/ui/label'
    | '/ui/loading-state'
    | '/ui/login-form'
    | '/ui/modal'
    | '/ui/pill'
    | '/ui/progress'
    | '/ui/radio'
    | '/ui/range'
    | '/ui/select'
    | '/ui/sidebar'
    | '/ui/skeleton'
    | '/ui/spinner'
    | '/ui/stack'
    | '/ui/switch'
    | '/ui/table'
    | '/ui/tabs'
    | '/ui/text'
    | '/ui/textarea'
    | '/ui/theme-switch'
    | '/ui/toast'
    | '/ui/tooltip'
    | '/ui/use-form'
    | '/ui/utilities'
    | '/icons'
    | '/ui'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/login'
    | '/register'
    | '/ui-test'
    | '/users'
    | '/admin/approvals'
    | '/admin/audit'
    | '/admin/invites'
    | '/icons/_layout'
    | '/icons/getting-started'
    | '/ui/_layout'
    | '/ui/getting-started'
    | '/ui/_layout/alert'
    | '/ui/_layout/badge'
    | '/ui/_layout/banner'
    | '/ui/_layout/button'
    | '/ui/_layout/button-group'
    | '/ui/_layout/card'
    | '/ui/_layout/checkbox'
    | '/ui/_layout/code-block'
    | '/ui/_layout/color-picker'
    | '/ui/_layout/empty-state'
    | '/ui/_layout/error-summary'
    | '/ui/_layout/fieldset'
    | '/ui/_layout/file-input'
    | '/ui/_layout/form'
    | '/ui/_layout/grid'
    | '/ui/_layout/heading'
    | '/ui/_layout/input'
    | '/ui/_layout/input-group'
    | '/ui/_layout/label'
    | '/ui/_layout/loading-state'
    | '/ui/_layout/login-form'
    | '/ui/_layout/modal'
    | '/ui/_layout/pill'
    | '/ui/_layout/progress'
    | '/ui/_layout/radio'
    | '/ui/_layout/range'
    | '/ui/_layout/select'
    | '/ui/_layout/sidebar'
    | '/ui/_layout/skeleton'
    | '/ui/_layout/spinner'
    | '/ui/_layout/stack'
    | '/ui/_layout/switch'
    | '/ui/_layout/table'
    | '/ui/_layout/tabs'
    | '/ui/_layout/text'
    | '/ui/_layout/textarea'
    | '/ui/_layout/theme-switch'
    | '/ui/_layout/toast'
    | '/ui/_layout/tooltip'
    | '/ui/_layout/use-form'
    | '/ui/_layout/utilities'
    | '/icons/_layout/'
    | '/ui/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  UiTestRoute: typeof UiTestRoute
  UsersRoute: typeof UsersRoute
  AdminApprovalsRoute: typeof AdminApprovalsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminInvitesRoute: typeof AdminInvitesRoute
  IconsLayoutRoute: typeof IconsLayoutRouteWithChildren
  IconsGettingStartedRoute: typeof IconsGettingStartedRoute
  UiLayoutRoute: typeof UiLayoutRouteWithChildren
  UiGettingStartedRoute: typeof UiGettingStartedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui-test': {
      id: '/ui-test'
      path: '/ui-test'
      fullPath: '/ui-test'
      preLoaderRoute: typeof UiTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/approvals': {
      id: '/admin/approvals'
      path: '/admin/approvals'
      fullPath: '/admin/approvals'
      preLoaderRoute: typeof AdminApprovalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/invites': {
      id: '/admin/invites'
      path: '/admin/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AdminInvitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icons/_layout': {
      id: '/icons/_layout'
      path: '/icons'
      fullPath: '/icons'
      preLoaderRoute: typeof IconsLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icons/getting-started': {
      id: '/icons/getting-started'
      path: '/icons/getting-started'
      fullPath: '/icons/getting-started'
      preLoaderRoute: typeof IconsGettingStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui/_layout': {
      id: '/ui/_layout'
      path: '/ui'
      fullPath: '/ui'
      preLoaderRoute: typeof UiLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ui/getting-started': {
      id: '/ui/getting-started'
      path: '/ui/getting-started'
      fullPath: '/ui/getting-started'
      preLoaderRoute: typeof UiGettingStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icons/_layout/': {
      id: '/icons/_layout/'
      path: '/'
      fullPath: '/icons/'
      preLoaderRoute: typeof IconsLayoutIndexRouteImport
      parentRoute: typeof IconsLayoutRoute
    }
    '/ui/_layout/': {
      id: '/ui/_layout/'
      path: '/'
      fullPath: '/ui/'
      preLoaderRoute: typeof UiLayoutIndexRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/alert': {
      id: '/ui/_layout/alert'
      path: '/alert'
      fullPath: '/ui/alert'
      preLoaderRoute: typeof UiLayoutAlertRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/badge': {
      id: '/ui/_layout/badge'
      path: '/badge'
      fullPath: '/ui/badge'
      preLoaderRoute: typeof UiLayoutBadgeRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/banner': {
      id: '/ui/_layout/banner'
      path: '/banner'
      fullPath: '/ui/banner'
      preLoaderRoute: typeof UiLayoutBannerRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/button': {
      id: '/ui/_layout/button'
      path: '/button'
      fullPath: '/ui/button'
      preLoaderRoute: typeof UiLayoutButtonRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/button-group': {
      id: '/ui/_layout/button-group'
      path: '/button-group'
      fullPath: '/ui/button-group'
      preLoaderRoute: typeof UiLayoutButtonGroupRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/card': {
      id: '/ui/_layout/card'
      path: '/card'
      fullPath: '/ui/card'
      preLoaderRoute: typeof UiLayoutCardRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/checkbox': {
      id: '/ui/_layout/checkbox'
      path: '/checkbox'
      fullPath: '/ui/checkbox'
      preLoaderRoute: typeof UiLayoutCheckboxRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/code-block': {
      id: '/ui/_layout/code-block'
      path: '/code-block'
      fullPath: '/ui/code-block'
      preLoaderRoute: typeof UiLayoutCodeBlockRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/color-picker': {
      id: '/ui/_layout/color-picker'
      path: '/color-picker'
      fullPath: '/ui/color-picker'
      preLoaderRoute: typeof UiLayoutColorPickerRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/empty-state': {
      id: '/ui/_layout/empty-state'
      path: '/empty-state'
      fullPath: '/ui/empty-state'
      preLoaderRoute: typeof UiLayoutEmptyStateRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/error-summary': {
      id: '/ui/_layout/error-summary'
      path: '/error-summary'
      fullPath: '/ui/error-summary'
      preLoaderRoute: typeof UiLayoutErrorSummaryRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/fieldset': {
      id: '/ui/_layout/fieldset'
      path: '/fieldset'
      fullPath: '/ui/fieldset'
      preLoaderRoute: typeof UiLayoutFieldsetRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/file-input': {
      id: '/ui/_layout/file-input'
      path: '/file-input'
      fullPath: '/ui/file-input'
      preLoaderRoute: typeof UiLayoutFileInputRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/form': {
      id: '/ui/_layout/form'
      path: '/form'
      fullPath: '/ui/form'
      preLoaderRoute: typeof UiLayoutFormRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/grid': {
      id: '/ui/_layout/grid'
      path: '/grid'
      fullPath: '/ui/grid'
      preLoaderRoute: typeof UiLayoutGridRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/heading': {
      id: '/ui/_layout/heading'
      path: '/heading'
      fullPath: '/ui/heading'
      preLoaderRoute: typeof UiLayoutHeadingRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/input': {
      id: '/ui/_layout/input'
      path: '/input'
      fullPath: '/ui/input'
      preLoaderRoute: typeof UiLayoutInputRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/input-group': {
      id: '/ui/_layout/input-group'
      path: '/input-group'
      fullPath: '/ui/input-group'
      preLoaderRoute: typeof UiLayoutInputGroupRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/label': {
      id: '/ui/_layout/label'
      path: '/label'
      fullPath: '/ui/label'
      preLoaderRoute: typeof UiLayoutLabelRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/loading-state': {
      id: '/ui/_layout/loading-state'
      path: '/loading-state'
      fullPath: '/ui/loading-state'
      preLoaderRoute: typeof UiLayoutLoadingStateRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/login-form': {
      id: '/ui/_layout/login-form'
      path: '/login-form'
      fullPath: '/ui/login-form'
      preLoaderRoute: typeof UiLayoutLoginFormRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/modal': {
      id: '/ui/_layout/modal'
      path: '/modal'
      fullPath: '/ui/modal'
      preLoaderRoute: typeof UiLayoutModalRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/pill': {
      id: '/ui/_layout/pill'
      path: '/pill'
      fullPath: '/ui/pill'
      preLoaderRoute: typeof UiLayoutPillRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/progress': {
      id: '/ui/_layout/progress'
      path: '/progress'
      fullPath: '/ui/progress'
      preLoaderRoute: typeof UiLayoutProgressRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/radio': {
      id: '/ui/_layout/radio'
      path: '/radio'
      fullPath: '/ui/radio'
      preLoaderRoute: typeof UiLayoutRadioRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/range': {
      id: '/ui/_layout/range'
      path: '/range'
      fullPath: '/ui/range'
      preLoaderRoute: typeof UiLayoutRangeRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/select': {
      id: '/ui/_layout/select'
      path: '/select'
      fullPath: '/ui/select'
      preLoaderRoute: typeof UiLayoutSelectRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/sidebar': {
      id: '/ui/_layout/sidebar'
      path: '/sidebar'
      fullPath: '/ui/sidebar'
      preLoaderRoute: typeof UiLayoutSidebarRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/skeleton': {
      id: '/ui/_layout/skeleton'
      path: '/skeleton'
      fullPath: '/ui/skeleton'
      preLoaderRoute: typeof UiLayoutSkeletonRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/spinner': {
      id: '/ui/_layout/spinner'
      path: '/spinner'
      fullPath: '/ui/spinner'
      preLoaderRoute: typeof UiLayoutSpinnerRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/stack': {
      id: '/ui/_layout/stack'
      path: '/stack'
      fullPath: '/ui/stack'
      preLoaderRoute: typeof UiLayoutStackRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/switch': {
      id: '/ui/_layout/switch'
      path: '/switch'
      fullPath: '/ui/switch'
      preLoaderRoute: typeof UiLayoutSwitchRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/table': {
      id: '/ui/_layout/table'
      path: '/table'
      fullPath: '/ui/table'
      preLoaderRoute: typeof UiLayoutTableRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/tabs': {
      id: '/ui/_layout/tabs'
      path: '/tabs'
      fullPath: '/ui/tabs'
      preLoaderRoute: typeof UiLayoutTabsRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/text': {
      id: '/ui/_layout/text'
      path: '/text'
      fullPath: '/ui/text'
      preLoaderRoute: typeof UiLayoutTextRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/textarea': {
      id: '/ui/_layout/textarea'
      path: '/textarea'
      fullPath: '/ui/textarea'
      preLoaderRoute: typeof UiLayoutTextareaRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/theme-switch': {
      id: '/ui/_layout/theme-switch'
      path: '/theme-switch'
      fullPath: '/ui/theme-switch'
      preLoaderRoute: typeof UiLayoutThemeSwitchRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/toast': {
      id: '/ui/_layout/toast'
      path: '/toast'
      fullPath: '/ui/toast'
      preLoaderRoute: typeof UiLayoutToastRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/tooltip': {
      id: '/ui/_layout/tooltip'
      path: '/tooltip'
      fullPath: '/ui/tooltip'
      preLoaderRoute: typeof UiLayoutTooltipRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/use-form': {
      id: '/ui/_layout/use-form'
      path: '/use-form'
      fullPath: '/ui/use-form'
      preLoaderRoute: typeof UiLayoutUseFormRouteImport
      parentRoute: typeof UiLayoutRoute
    }
    '/ui/_layout/utilities': {
      id: '/ui/_layout/utilities'
      path: '/utilities'
      fullPath: '/ui/utilities'
      preLoaderRoute: typeof UiLayoutUtilitiesRouteImport
      parentRoute: typeof UiLayoutRoute
    }
  }
}

interface IconsLayoutRouteChildren {
  IconsLayoutIndexRoute: typeof IconsLayoutIndexRoute
}

const IconsLayoutRouteChildren: IconsLayoutRouteChildren = {
  IconsLayoutIndexRoute: IconsLayoutIndexRoute,
}

const IconsLayoutRouteWithChildren = IconsLayoutRoute._addFileChildren(
  IconsLayoutRouteChildren,
)

interface UiLayoutRouteChildren {
  UiLayoutAlertRoute: typeof UiLayoutAlertRoute
  UiLayoutBadgeRoute: typeof UiLayoutBadgeRoute
  UiLayoutBannerRoute: typeof UiLayoutBannerRoute
  UiLayoutButtonRoute: typeof UiLayoutButtonRoute
  UiLayoutButtonGroupRoute: typeof UiLayoutButtonGroupRoute
  UiLayoutCardRoute: typeof UiLayoutCardRoute
  UiLayoutCheckboxRoute: typeof UiLayoutCheckboxRoute
  UiLayoutCodeBlockRoute: typeof UiLayoutCodeBlockRoute
  UiLayoutColorPickerRoute: typeof UiLayoutColorPickerRoute
  UiLayoutEmptyStateRoute: typeof UiLayoutEmptyStateRoute
  UiLayoutErrorSummaryRoute: typeof UiLayoutErrorSummaryRoute
  UiLayoutFieldsetRoute: typeof UiLayoutFieldsetRoute
  UiLayoutFileInputRoute: typeof UiLayoutFileInputRoute
  UiLayoutFormRoute: typeof UiLayoutFormRoute
  UiLayoutGridRoute: typeof UiLayoutGridRoute
  UiLayoutHeadingRoute: typeof UiLayoutHeadingRoute
  UiLayoutInputRoute: typeof UiLayoutInputRoute
  UiLayoutInputGroupRoute: typeof UiLayoutInputGroupRoute
  UiLayoutLabelRoute: typeof UiLayoutLabelRoute
  UiLayoutLoadingStateRoute: typeof UiLayoutLoadingStateRoute
  UiLayoutLoginFormRoute: typeof UiLayoutLoginFormRoute
  UiLayoutModalRoute: typeof UiLayoutModalRoute
  UiLayoutPillRoute: typeof UiLayoutPillRoute
  UiLayoutProgressRoute: typeof UiLayoutProgressRoute
  UiLayoutRadioRoute: typeof UiLayoutRadioRoute
  UiLayoutRangeRoute: typeof UiLayoutRangeRoute
  UiLayoutSelectRoute: typeof UiLayoutSelectRoute
  UiLayoutSidebarRoute: typeof UiLayoutSidebarRoute
  UiLayoutSkeletonRoute: typeof UiLayoutSkeletonRoute
  UiLayoutSpinnerRoute: typeof UiLayoutSpinnerRoute
  UiLayoutStackRoute: typeof UiLayoutStackRoute
  UiLayoutSwitchRoute: typeof UiLayoutSwitchRoute
  UiLayoutTableRoute: typeof UiLayoutTableRoute
  UiLayoutTabsRoute: typeof UiLayoutTabsRoute
  UiLayoutTextRoute: typeof UiLayoutTextRoute
  UiLayoutTextareaRoute: typeof UiLayoutTextareaRoute
  UiLayoutThemeSwitchRoute: typeof UiLayoutThemeSwitchRoute
  UiLayoutToastRoute: typeof UiLayoutToastRoute
  UiLayoutTooltipRoute: typeof UiLayoutTooltipRoute
  UiLayoutUseFormRoute: typeof UiLayoutUseFormRoute
  UiLayoutUtilitiesRoute: typeof UiLayoutUtilitiesRoute
  UiLayoutIndexRoute: typeof UiLayoutIndexRoute
}

const UiLayoutRouteChildren: UiLayoutRouteChildren = {
  UiLayoutAlertRoute: UiLayoutAlertRoute,
  UiLayoutBadgeRoute: UiLayoutBadgeRoute,
  UiLayoutBannerRoute: UiLayoutBannerRoute,
  UiLayoutButtonRoute: UiLayoutButtonRoute,
  UiLayoutButtonGroupRoute: UiLayoutButtonGroupRoute,
  UiLayoutCardRoute: UiLayoutCardRoute,
  UiLayoutCheckboxRoute: UiLayoutCheckboxRoute,
  UiLayoutCodeBlockRoute: UiLayoutCodeBlockRoute,
  UiLayoutColorPickerRoute: UiLayoutColorPickerRoute,
  UiLayoutEmptyStateRoute: UiLayoutEmptyStateRoute,
  UiLayoutErrorSummaryRoute: UiLayoutErrorSummaryRoute,
  UiLayoutFieldsetRoute: UiLayoutFieldsetRoute,
  UiLayoutFileInputRoute: UiLayoutFileInputRoute,
  UiLayoutFormRoute: UiLayoutFormRoute,
  UiLayoutGridRoute: UiLayoutGridRoute,
  UiLayoutHeadingRoute: UiLayoutHeadingRoute,
  UiLayoutInputRoute: UiLayoutInputRoute,
  UiLayoutInputGroupRoute: UiLayoutInputGroupRoute,
  UiLayoutLabelRoute: UiLayoutLabelRoute,
  UiLayoutLoadingStateRoute: UiLayoutLoadingStateRoute,
  UiLayoutLoginFormRoute: UiLayoutLoginFormRoute,
  UiLayoutModalRoute: UiLayoutModalRoute,
  UiLayoutPillRoute: UiLayoutPillRoute,
  UiLayoutProgressRoute: UiLayoutProgressRoute,
  UiLayoutRadioRoute: UiLayoutRadioRoute,
  UiLayoutRangeRoute: UiLayoutRangeRoute,
  UiLayoutSelectRoute: UiLayoutSelectRoute,
  UiLayoutSidebarRoute: UiLayoutSidebarRoute,
  UiLayoutSkeletonRoute: UiLayoutSkeletonRoute,
  UiLayoutSpinnerRoute: UiLayoutSpinnerRoute,
  UiLayoutStackRoute: UiLayoutStackRoute,
  UiLayoutSwitchRoute: UiLayoutSwitchRoute,
  UiLayoutTableRoute: UiLayoutTableRoute,
  UiLayoutTabsRoute: UiLayoutTabsRoute,
  UiLayoutTextRoute: UiLayoutTextRoute,
  UiLayoutTextareaRoute: UiLayoutTextareaRoute,
  UiLayoutThemeSwitchRoute: UiLayoutThemeSwitchRoute,
  UiLayoutToastRoute: UiLayoutToastRoute,
  UiLayoutTooltipRoute: UiLayoutTooltipRoute,
  UiLayoutUseFormRoute: UiLayoutUseFormRoute,
  UiLayoutUtilitiesRoute: UiLayoutUtilitiesRoute,
  UiLayoutIndexRoute: UiLayoutIndexRoute,
}

const UiLayoutRouteWithChildren = UiLayoutRoute._addFileChildren(
  UiLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  UiTestRoute: UiTestRoute,
  UsersRoute: UsersRoute,
  AdminApprovalsRoute: AdminApprovalsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminInvitesRoute: AdminInvitesRoute,
  IconsLayoutRoute: IconsLayoutRouteWithChildren,
  IconsGettingStartedRoute: IconsGettingStartedRoute,
  UiLayoutRoute: UiLayoutRouteWithChildren,
  UiGettingStartedRoute: UiGettingStartedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
